module.exports = __webpack_public_path__ + "media/fr_fr_s4_Travis.453db9b8.oga";